import {ListItem, ListItemText, Typography} from "@mui/material";
import AvatarWidget from "../../../../../appfw/ui/users/AvatarWidget.tsx";
import {useUser} from "../../../../../appfw/users/User.tsx";
import {useMemo} from "react";
import {Member} from "../../../../api-client/EventerConsoleApiClient.ts";
import DialogActionButton from "../../../../../appfw/ui/dialogs/DialogActionButton.tsx";
import {RemoveCircle} from "@mui/icons-material";

interface MemberProps {
    readonly member: Member;
    readonly remove?: ((memberId: string) => Promise<void>);
}

export default function MemberItem(props: MemberProps) {

    const userHook = useUser(props.member.user.id)

    const remove = props.remove
    return useMemo(() =>
        (
            <ListItem
                secondaryAction={
                    (remove && props.member.role !== "owner") &&
                    (
                        <DialogActionButton
                            outlet={<RemoveCircle/>}
                            dialogTitle={"Nutzer entfernen"}
                            dialogContent={"Möchten Sie den Nutzer " + (props.member.user.name ?? props.member.email) + " wirklich entfernen?"}
                            dialogActions={[
                                {label: "Nein"},
                                {
                                    label: "Ja",
                                    action: () => remove(props.member.user.id)
                                },
                            ]}
                        />
                    )
                }>
                <AvatarWidget id={props.member.user.id}/>
                <ListItemText sx={{marginLeft: 1}}
                              primary={
                                  <>
                                      {userHook.data?.name ?? ""}
                                      {props.member.role === "owner" && " (Eigentümer)"}
                                  </>
                              }
                              secondary={
                                  <Typography component="span" variant="body2">
                                      {props.member.email}
                                  </Typography>
                              }
                />
            </ListItem>
        ), [userHook.data, props]
    )
}